// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UIwf","buttons":"Footer_buttons__26hOI"};